export var appConfig = {
  WelcomeMessage: "Welcome to Amadeus Online Portal",
  ClientTitle: "Online Portal",
  showPasswordChangeButtonOnLogin: true,
  showLanguageChangeButtonOnLogin: true,
  loginText: "",
  performanceChartSecondSerieName: "Cumulative Performance",
  portfolioGridSmallScreenColumns: [
    "SecName",
    "Quantity",
    "Currency",
    "CurrentPrice",
    "Valuation",
    "ProfitPerc",
  ],
  transactionsGridSmallScreenColumns: [
    "SecName",
    "QuantityWithoutCash",
    "TransAmountRC",
    "TransDate",
    "Description",
  ],
  hidePerformanceChartListColumn: true,
  clientSpecificColumnHidden: ["InterestFrequency", "SecISIN"],
  hideSecurityPricesVolume: false,
  sortTransactionsByDefault: false,
  multiSelectWidthSettings: true,
  dropdownWidthSettings: true,
  hideIncludeIgnoredTransactions: true,
  setCarouselTimeout: 10000,
  version: 3.1,
  showThemeSelection: false,
  menuShowRiskProfile: false,
  menuShowMainWindow: false,
  menuShowClientContacts: false,
  menuShowGenericForms: false,
  appUserWelcome: false,
  allowTracking: false,
  translationsVersion: 3.1,
  InsaCronAvailable: true,
  availableLocales: ["en-US", "de-DE", "it-IT", "fr-FR"],
  SecMainClass_LIQUIDITY: 0,
  chartColors: [
    "#9a9839",
    "#77762b",
    "#4e4d1c",
    "#bdbc81",
    "#808080",
    "#464747",
    "#373838",
    "#d2d2d2",
    "#373838",
    "#ac926a",
    "#dda148",
  ],
  NavigateToReferrerOnLogout: false,
  ActiveIsChecked: false,
  menuShowInsaTrader: false,
  useLegacyIcons: true,
};



// WEBPACK FOOTER //
// ./insa-css/insa-clients/Amadeus/insaweb.config.ts